export const learnToPlayData = [
  // {
  //   title: `How to Purchase Card Packs for Identities and Predictions`,
  //   videoUrl: `https://twotwentyk.portal.trainn.co/share/W67Xz79oQ9xeGLK7hiD0qw/embed`,
  //   textVersion: {
  //     title: `How to Purchase Card Packs for Identities and Predictions`,
  //     descr: `In this guide, you'll learn the steps to purchase card packs, which are essential for creating identities and making predictions.`,
  //     steps: [
  //       {
  //         stepTitle: `Step 1: Access the Buy Packs Section`,
  //         stepsList: [
  //           `From your dashboard, locate and click on Buy Packs in the main navigation bar.`,
  //         ],
  //       },
  //       {
  //         stepTitle: `Step 2: Understand Pack Collections`,
  //         stepsList: [
  //           `Packs are organized by collection, each with a specific theme and type.`,
  //           `For example, the theme of one collection is 2025 PGA Players and the type is Identity.`,
  //           `The price of this pack is $2.`,
  //         ],
  //       },
  //       {
  //         stepTitle: `Step 3: Purchase a Single Pack`,
  //         stepsList: [
  //           `To buy a single pack, click the Buy Now button.`,
  //           `Review the card details section to see pack properties, the number of cards, and the multi-pack purchase widget.`,
  //         ],
  //       },
  //       {
  //         stepTitle: `Step 4: Explore Prediction Pack Collection`,
  //         stepsList: [
  //           `This collection contains packs for making predictions with the identities you create.`,
  //           `These packs also include valuable prize cards.`,
  //           `Click Buy Now to purchase a single pack.`,
  //         ],
  //       },
  //       {
  //         stepTitle: `Step 5: Select Payment Method`,
  //         stepsList: [
  //           `Choose your preferred payment method and click the confirmation buttons.`,
  //         ],
  //       },
  //       {
  //         stepTitle: `Step 6: Purchase Multiple Packs`,
  //         stepsList: [
  //           `Select the pack you want to buy multiple of.`,
  //           `Enter the desired quantity in the multi-pack purchase section and click Buy Now.`,
  //           `Select your payment method again.`,
  //         ],
  //       },
  //       {
  //         stepTitle: `Step 7: Review Your Purchases`,
  //         stepsList: [`Click on Card Packs to view your purchased packs.`],
  //       },
  //     ],
  //     finalText: `Follow these steps to successfully purchase card packs and enhance your identity and prediction capabilities.`
  //   },
  // },
  {
    title: `How to craft Predictions`,
    videoUrl: `https://www.youtube-nocookie.com/embed/UbBCoS683EA?si=UR6WHOpuIH5hiUm0`,
    textVersion: {
      title: ``,
      descr: ``,
      steps: [
        {
          stepTitle: ``,
          stepsList: [],
        },
      ],
      finalText: ``,
    },
  },
  {
    title: `How to craft Identities`,
    videoUrl: `https://www.youtube-nocookie.com/embed/L4V4V-0jXZ4?si=551B1Y82hecWmPi9`,
    textVersion: {
      title: ``,
      descr: ``,
      steps: [
        {
          stepTitle: ``,
          stepsList: [],
        },
      ],
      finalText: ``,
    },
  },
];

// template
// {
//   title: ``,
//   videoUrl: ``,
//   textVersion: {
//     title: ``,
//     descr: ``,
//     steps: [
//       {
//         stepTitle: ``,
//         stepsList: [],
//       },
//     ],
//     finalText: ``,
//   },
// },
